export default __webpack_public_path__ + "static/media/adrift-desktop.4d45789b.mp4";